import React from 'preact/compat';
import { h } from 'preact';
import Button, { ButtonProps } from '@ingka/button';
import { PREFIX } from 'list/DesignSystem/constants';
import './button.scss';

export default (props: ButtonProps) => <Button prefix={PREFIX} {...props} />;
